import { render, staticRenderFns } from "./loko_general_tab.vue?vue&type=template&id=cddcc8da&scoped=true&"
import script from "./loko_general_tab.vue?vue&type=script&lang=js&"
export * from "./loko_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddcc8da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cddcc8da')) {
      api.createRecord('cddcc8da', component.options)
    } else {
      api.reload('cddcc8da', component.options)
    }
    module.hot.accept("./loko_general_tab.vue?vue&type=template&id=cddcc8da&scoped=true&", function () {
      api.rerender('cddcc8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/loko/location/tabs/loko_general_tab.vue"
export default component.exports